import { OrderService } from './../../service/orderService/order.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { Component, OnInit, ViewChild } from '@angular/core';
import { StarRatingComponent } from 'ng-starrating';
import { NgbRatingConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.scss']
})
export class OrderDetailComponent implements OnInit {
dishes:any=[] ;
currentRate:any='5'
  displayedColumns: string[] = ['image','name', 'Quantity', 'price','sellPrice', 'Total'];
  dataSource = new MatTableDataSource();
  editId:any;
  order:any;
  Object = Object
constructor(private route:Router,private activeRoute:ActivatedRoute,private ApiService:OrderService, config: NgbRatingConfig)
{
  config.max = 5;
  config.readonly = true;
  this.order=
  {
    address:{},
    customers:{fullname:'name',email:'email',id:'',image:{url:''},countryCode:''},
    voucher:{code:'',amount:'',voucher_type:''}
  }
  this.dishes=
  {
    attribute:{price:'',retail_price:'',value:''},
  }
this.editId=this.activeRoute.snapshot.paramMap.get('id')
this.getOrderDetail();
}
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  ngOnInit() {
    this.dataSource.sort = this.sort;
  }
  onRate($event:{oldValue:number, newValue:number, starRating:StarRatingComponent}) {
    alert(`Old Value:${$event.oldValue}, 
      New Value: ${$event.newValue}, 
      Checked Color: ${$event.starRating.checkedcolor}, 
      Unchecked Color: ${$event.starRating.uncheckedcolor}`);
  }
  getPrice(dish)
  {
    let price=0
    dish.attribute.forEach(element => {
    if(element.quantity>0)
    {
    price=price+element.quantity*element.retail_price
    }
   
    // else if(element.quantity)
  // dish.aprice=a
   });
   return price
    // dish.aprice=.retail_price * price.quantity
    
 }
  getOrderDetail()
  {
    this.ApiService.getOrderDetail(this.editId).then((res:any)=>
    {
      this.dishes=res.dishes
      this.dataSource.data=this.dishes
     this.order=res
     console.log(this.order)
      console.log(res)
    })
  }
  editOrderDetail()
  {
    this.ApiService.EditOrderDetail(this.editId,this.order).then((res)=>
    {
      location.reload();
    })
  }
  viewProfile()
  {
    this.route.navigate(['dashboard/viewProfile',this.order.customers.id])
  }

}
